<template>
  <div>
    <canvas ref="chartWrapper"></canvas>
  </div>
</template>

<script>
import {
  Chart,
  ArcElement,
  DoughnutController,
  CategoryScale,
  LinearScale,
  Decimation,
  Legend,
  Title,
  Tooltip
} from 'chart.js'
Chart.register(
  ArcElement,
  DoughnutController,
  CategoryScale,
  LinearScale,
  Decimation,
  Legend,
  Title,
  Tooltip
)

export default {
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      chartBar: null,
    }
  },

  watch: {
    chartdata: {
      deep: true,
      handler: function(val) {
        this.chartBar.clear()
        this.chartBar.data = val
        this.chartBar.update()
      }
    },

    options: {
      deep: true,
      handler: function(val) {
        this.chartBar.clear()
        this.chartBar.options = val
        this.chartBar.update()
      }
    },
  },

  mounted() {
    this.chartBar = new Chart(this.$refs['chartWrapper'], {
      type: 'doughnut',
      data: this.chartdata,
      options: this.options
    })
  },

  beforeDestroy() {
    this.chartBar.destroy();
  },
}



// import { Doughnut } from 'vue-chartjs'

// export default {
//   extends: Doughnut,
//   props: {
//     chartdata: {
//       type: Object,
//       default: null,
//     },
//     options: {
//       type: Object,
//       default: null,
//     },
//   },
//   mounted() {
//     this.renderChart(this.chartdata, this.options)
//   },
// }
</script>

<style lang="scss" scoped>
canvas {
  width: 100% !important;
}
</style>